import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import type { User } from '@/types/auth';
import { Navigation } from './Navigation';
import { UserMenu } from './UserMenu';

interface HeaderProps {
  user: User;
}

export const Header: React.FC<HeaderProps> = ({ user }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link 
            to="/dashboard" 
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            <img 
              src="/SolasLite.svg" 
              alt="Solas Lite" 
              className="h-10 w-auto rounded-md"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Navigation user={user} />
            <UserMenu user={user} />
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle menu"
          >
            <span className="material-symbols-outlined text-2xl">
              {mobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <Navigation 
              user={user} 
              isMobile 
              onNavigate={() => setMobileMenuOpen(false)} 
            />
            <div className="mt-4 pt-4 border-t border-gray-200">
              <UserMenu user={user} />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

